@for (item of prescriptionSolution.listSolutionMedicine; track item; let index = $index) {
  <div class="col-12 col-sm-6 col-md-4">
    <label>Nome medicamento: </label>
    <p>{{item.medicineName}}</p>
  </div>
  <div class="row row-block">
    <div class="col-12 col-sm-6 col-md-4">
      <label>Quantidade: </label>
      <p>{{item.prescriptionSolutionMedicine.quantity}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
      <label>Dose a ser administrada: </label>
      <p>{{item.doseToAdministeredName}}</p>
    </div>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Unidade: </label>
    <p>{{item.measurementUnitName}}</p>
  </div>
}
<div class="row row-block">
  <div class="col-12 col-sm-6 col-md-4">
    <label>Apresentação: </label>
    <p>{{prescriptionSolution.presentationName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Uso: </label>
    <p>{{prescriptionSolution.usage}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Forma de consumo:</label>
    <p>{{prescriptionSolution.administrationTypeName}}</p>
    <p>{{prescriptionSolution.prescriptionSolution.administrationType}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Frequencia: </label>
    <p>{{prescriptionSolution.frequencyName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Período de tratamento: </label>
    <p>{{prescriptionSolution.treatmentPeriodName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Diluição: </label>
    <p>{{prescriptionSolution.prescriptionSolution.dilution ? prescriptionSolution.prescriptionSolution.dilution :
    prescriptionSolution.dilutionName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Local de administração: </label>
    <p>{{prescriptionSolution.lookupAdministrationLocationName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Observação: </label>
    <p>{{prescriptionSolution.prescriptionSolution.observation}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Unidade de diluição: </label>
    <p>{{prescriptionSolution.dilutionUnitName}}</p>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <label>Quantidade de diluição: </label>
    <p>{{prescriptionSolution.prescriptionSolution.dilutionQuantity}}</p>
  </div>
</div>